import { StorageAdapter } from './storageInterface';

/**
 * Adapter fallback utilisant localStorage
 * Pour environnement web ou quand Median n'est pas disponible
 */
export class WebStorageAdapter implements StorageAdapter {
  private prefix = 'koken_storage_';

  async get<T>(key: string): Promise<T | null> {
    try {
      const data = localStorage.getItem(this.prefix + key);
      return data ? JSON.parse(data) as T : null;
    } catch (error) {
      console.error(`[WebStorage] Error getting ${key}:`, error);
      return null;
    }
  }

  async set<T>(key: string, value: T): Promise<void> {
    try {
      localStorage.setItem(this.prefix + key, JSON.stringify(value));
    } catch (error) {
      console.error(`[WebStorage] Error setting ${key}:`, error);
      throw error;
    }
  }

  async remove(key: string): Promise<void> {
    localStorage.removeItem(this.prefix + key);
  }

  async clear(): Promise<void> {
    const keysToRemove = Object.keys(localStorage)
      .filter(key => key.startsWith(this.prefix));
    keysToRemove.forEach(key => localStorage.removeItem(key));
  }

  async keys(): Promise<string[]> {
    return Object.keys(localStorage)
      .filter(key => key.startsWith(this.prefix))
      .map(key => key.replace(this.prefix, ''));
  }
}
